<div class="mb-5 mct-flex mct-row mct-justify-between mct-items-stretch">
  <h4>{{ 'communications.mass-comm-message-admin.analytics.undeliverable-emails-grid.heading' | translate | titlecase }}
  </h4>
  <button pButton type="button" (click)="exportEmails()" [disabled]="exporting" class="atlas-btn atlas-btn-primary">
    <wl-busy [show]="exporting"></wl-busy>
    {{ 'communications.mass-comm-message-admin.analytics.undeliverable-emails-grid.export' | translate | titlecase }}
  </button>
</div>
<p-table [showGridlines]="true" [value]="searchResult?.Result" [rows]="searchParams ? searchParams.PageSize : 20"
  [totalRecords]="searchResult?.TotalCount" (onLazyLoad)="lazyLoad($event)" [lazyLoadOnInit]="false" [paginator]="true"
  [filterDelay]="500" [lazy]="true" [loading]="loading">
  <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
    <SortAltIcon *ngIf="sortOrder === 0">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
    </SortAltIcon>
    <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
    </SortAmountUpAltIcon>
    <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
    </SortAmountDownIcon>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="ProfileName" style="min-width: 400px">
        {{ 'communications.mass-comm-message-admin.analytics.undeliverable-emails-grid.profile-name' | translate |
        ucfirst }}
        <p-sortIcon field="ProfileName"></p-sortIcon>
      </th>
      <th pSortableColumn="FailedEmailCount">
        {{ 'communications.mass-comm-message-admin.analytics.undeliverable-emails-grid.failed-emails-count' | translate
        | ucfirst }}
        <p-sortIcon field="FailedEmailsCount"></p-sortIcon>
      </th>
      <th pSortableColumn="EmailAddress" style="min-width: 400px">
        {{ 'communications.mass-comm-message-admin.analytics.undeliverable-emails-grid.email-address' | translate |
        ucfirst }}
        <p-sortIcon field="EmailAddress"></p-sortIcon>
      </th>
    </tr>
    <tr>
      <th>
        <input pInputText type="text" [(ngModel)]="searchParams.ProfileName"
          [placeholder]="'communications.mass-comm-message-admin.analytics.undeliverable-emails-grid.name-filter' | translate | ucfirst"
          styleClass="p-column-filter" (input)="filterChanged()" />
      </th>
      <th style="max-width: 100px">
        <p-inputNumber
          [placeholder]="'communications.mass-comm-message-admin.analytics.undeliverable-emails-grid.count-filter' | translate | ucfirst"
          styleClass="p-column-filter" (onInput)="filterChanged()" (onClear)="filterChanged()" showClear="true"
          [(ngModel)]="searchParams.FailedEmailCount"></p-inputNumber>
      </th>
      <th>
        <input pInputText type="text"
          [placeholder]="'communications.mass-comm-message-admin.analytics.undeliverable-emails-grid.email-filter' | translate | ucfirst"
          styleClass="p-column-filter" (input)="filterChanged()" [(ngModel)]="searchParams.EmailAddress" />
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-email>
    <tr>
      <td>
        <a (click)="navigateToProfile(email.ProfileId)"> {{ email.ProfileName }}</a>
      </td>
      <td>
        {{ email.FailedEmailCount }}
      </td>
      <td>
        {{ email.EmailAddress }}
      </td>
    </tr>
  </ng-template>
</p-table>
<wl-page-size-dropdown [(pageSize)]="searchParams.PageSize" [pageSizes]="[20, 100, 0]"
  (pageSizeChange)="pageSizeChanged()"></wl-page-size-dropdown>
